import { Button, Form } from 'react-bootstrap';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import spinnerTitle from '../../others/spinnerTitle';
import { useEffect, useRef } from 'react';

interface CreateTeamFormProps {
    handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
    isSubmitting: boolean;
    error?: string;
}

const CreateTeamForm = ({ handleSubmit, isSubmitting, error }: CreateTeamFormProps) => {
    const { t } = useTranslation(['Warehouses', 'common']);
    const refInput = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setTimeout(() => {
            if (refInput.current) {
                refInput.current.focus();
            }
        }, 100);
    }, []);

    return (
        <Form className="d-flex flex-column h-100" onSubmit={handleSubmit}>
            <div className="off-create-team-form d-flex flex-column h-100">
                <div className="off-create-team-content px-3">
                    <Form.Group className="mb-3">
                        <label className="form-label text-muted" htmlFor="createTeamName">
                            {t('createTeam.labelName')}
                        </label>
                        <Field
                            innerRef={refInput}
                            required
                            id="createTeamName"
                            name="teamName"
                            className={`form-control ${error ? 'is-invalid' : ''}`}
                            autoFocus
                        />
                        {error ? <div className="invalid-feedback d-block">{error}</div> : null}
                    </Form.Group>
                </div>

                <div className="p-3 offcanvas-footer off-create-team-footer">
                    <div className="d-flex justify-content-end">
                        <Button type="submit" variant="info" disabled={isSubmitting} className="min100px">
                            {spinnerTitle(
                                <>
                                    <i className="bi bi-check2-all fs-14 me-2"></i>
                                    {t('common:buttons.create')}
                                </>,
                                isSubmitting,
                                t('common:buttons.creating'),
                            )}
                        </Button>
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default CreateTeamForm;
